import { useRef } from "react";
import { useCartService } from "../../../hooks/use-cart-service";
import { handleCookieConsent, setCookie } from "../../cookies/cookie-service";
import { getQueryStringParam } from "../../query-string";

export const useCj = () => {
	const cjEventId = getQueryStringParam("cjevent");
	const cookieSet = useRef(false);
	const { cart, setCartCustomField, cartLoading } = useCartService();

	handleCookieConsent("cje", "targeting");

	if (!cartLoading && cjEventId && !cookieSet.current) {
		if (cart?.custom.fields.cjEventId !== cjEventId)
			void setCartCustomField("cjEventId", cjEventId);

		const expiryDate = new Date();
		// 13 months
		expiryDate.setMonth(expiryDate.getMonth() + 13);
		console.log("Setting cj cookie");
		setCookie({
			name: "cje",
			value: cjEventId,
			requireConsent: "targeting",
			attributes: {
				expires: expiryDate,
				path: "/",
				secure: true,
				sameSite: "none",
			},
		});
		cookieSet.current = true;
	}
};
